import React from "react";
import SntLink from "@/components/ReactBootstrap/SntLink";

interface HelpSidebarItemProps {
  description?: string;
  linkText?: string;
  linkUrl?: string | { pathname: string };
  htmlContent?: string;
}

// Re-export type for external use
export type HelpSidebarLinkUrl = string | { pathname: string };

const HelpSidebarItem: React.FC<HelpSidebarItemProps> = ({
  description,
  linkText,
  linkUrl,
  htmlContent,
}) => {
  if (htmlContent) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
      />
    );
  }

  return (
    <>
      {description && <p className="mb-0">{description}</p>}
      {linkText && linkUrl && (
        <SntLink target="_blank" to={linkUrl}>
          {linkText}
        </SntLink>
      )}
    </>
  );
};

export default HelpSidebarItem;
